import { Component , Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FirebaseService } from '../../service/firebase.service';

@Component({
  selector: 'app-modal-tab',
  templateUrl: './modal-tab.component.html',
  styleUrls: ['./modal-tab.component.scss']
})
export class ModalTabComponent {
  public history:Array<any> = []
  constructor(public dialogRef: MatDialogRef<ModalTabComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _firebase: FirebaseService) {
    console.log(this.data)

    this.getHistoryData();
  }



  async getHistoryData() {
    let docs = await this._firebase.getHistoryFromDeviceId(this.data.device.docStatusId)

    docs.docs.map(v => {

      this.history.push(v.data())
    })


    console.log(this.history)
  }
}
